// frontend/components/providers/AuthProvider.tsx

"use client";

import React from "react";
import { SessionProvider } from "next-auth/react";

// NextAuth 세션 상태를 클라이언트 하위 컴포넌트 전역에 공급
// refetchOnWindowFocus(기본값 true)를 끔 — 창 포커스마다 세션을 다시 가져오면서
// 매번 새 객체 참조가 생성되어, 이를 deps로 사용하는 하위 컴포넌트의 effect가
// 불필요하게 재실행되고(예: 에디터 WebSocket 재연결) 화면이 깜빡이는 문제가 있었음.
// 탭 간 세션 동기화는 next-auth의 BroadcastChannel(스토리지 이벤트)로 이미 처리됨
export default function AuthProvider({ children }: { children: React.ReactNode }) {
  return <SessionProvider refetchOnWindowFocus={false}>{children}</SessionProvider>;
}